import { Navigate, useSearchParams } from 'react-router-dom';

/** Runs before the old Timesheets module guard, including for notification links. */
export function PersonalTimesheetLegacyRedirect({ children }: { children: React.ReactNode }) {
  const [params] = useSearchParams();
  const mode = params.get('personal');
  if (mode !== 'mine' && mode !== 'review') return <>{children}</>;
  const next = new URLSearchParams(params);
  next.delete('personal');
  if (mode === 'review') next.set('tab', 'admin-hours');
  return <Navigate replace to={`${mode === 'mine' ? '/my-hours' : '/employee-hours'}?${next}`} />;
}

